import { useEffect } from "react";
import { getToken } from "firebase/messaging";
import { firebaseMessaging, refreshFCMToken } from "../../utils/firebase";
import { setFCMToken } from "../../utils/tokenHandler";
import { useUpdateFcmToken } from "../../hooks/useNotifications";
import { useSessionUserDetails } from "../../hooks/useUserDetails";

const FCMLayout = ({ children }) => {
  const { mutate: updateFcmToken } = useUpdateFcmToken();
  const { data: userDetails } = useSessionUserDetails();

  const updateTokens = async () => {
    try {
      let firebaseFcmToken = await getToken(firebaseMessaging, {
        vapidKey: import.meta.env.VITE_VAPID_KEY,
      });

      if (!firebaseFcmToken) {
        firebaseFcmToken = await refreshFCMToken();
      }

      if (firebaseFcmToken) {
        setFCMToken(firebaseFcmToken);
        updateFcmToken({ fcm_token: firebaseFcmToken });
      } else {
        console.warn("Failed to obtain valid FCM token after refresh");
      }
    } catch (error) {
      console.error("Error updating FCM tokens:", error);
    }
  };

  useEffect(() => {
    if (userDetails) {
      updateTokens();
    }
  }, [userDetails]);

  useEffect(() => {
    const handleAppFocus = () => {
      if (userDetails) {
        updateTokens();
      }
    };

    window.addEventListener("focus", handleAppFocus);
    return () => window.removeEventListener("focus", handleAppFocus);
  }, [userDetails]);

  return <>{children}</>;
};

export default FCMLayout;
